import { z } from "zod";

/**
 * BAGLANTI YALNIZCA http/https — F-SCH-03b.
 *
 * `z.string().url()` `javascript:` ve `data:` adreslerini de GECERLI
 * sayiyor (`new URL()` ile dogruluyor). Bu adres ogrenci kartinda
 * tiklanabilir bir `<a href>` oluyor; koc hesabi ele gecirilmis biri
 * ogrencinin tarayicisinda kod calistirabilirdi. React 19 `javascript:`
 * adresini engelliyor ama korumayi istemciye birakmak, onu unutabilecek
 * bir yere koymak olurdu (CLAUDE.md kural 10) — mobil uygulama baska
 * bir cizici kullanacak.
 *
 * TEK KAYNAK — Codex tur 36 B6 (05.10.2026). Kural sunucuda Zod, panelde
 * ayri regex + `new URL` + uzunluk olarak iki kez yaziliydi; biri degisince
 * digeri sessizce eskide kalirdi. Sunucu (`program.controller.ts`) ve panel
 * (`gorev-icerigi.ts`) bu semayi kullaniyor. Bos alanin `null`a donmesi
 * istemcinin isi (form degeri), bu sema dolu bir adres bekliyor.
 */
export const baglantiSemasi = z
  .string()
  .trim()
  .max(2000, "Bağlantı en fazla 2000 karakter olabilir.")
  .url("Geçerli bir bağlantı yapıştırın.")
  .refine((u) => /^https?:\/\//i.test(u), "Bağlantı http:// ya da https:// ile başlamalı.");

/**
 * GÖRÜŞME (MEET) BAĞLANTISI — F-SES-02b (Emre 06.10.2026).
 *
 * `baglantiSemasi`nden daha dar: YALNIZ https. Bağlantı öğrencinin ve
 * velinin telefonunda "Görüşmeye katıl" düğmesi oluyor; şifresiz `http://`
 * bir görüşme adresi ağda okunabilir ve görüşmeye yabancı biri katılabilir.
 * Tercih `meet.google.com` ama başka https adresi (Zoom, Teams) reddedilmez —
 * kurum yarın başka araç kullanırsa alan işe yaramaz hâle gelmesin.
 */
export const meetBaglantisiSemasi = baglantiSemasi.refine(
  (u) => /^https:\/\//i.test(u),
  "Görüşme bağlantısı https:// ile başlamalı.",
);

/** Panel ipucu için: adres Google Meet mi (zorunlu değil, yalnız bilgi). */
export function googleMeetMi(adres: string): boolean {
  return /^https:\/\/meet\.google\.com\//i.test(adres.trim());
}
